function addMaterial(materials, item, options = {}) {
    if (!item || !item.resourceId) {
        return materials;
    }
    const materialType = options.materialType || '';
    const existed = materials.find(material => {
        const sameId = material.materialId === item.resourceId;
        const sameType = materialType
            ? material.materialType === materialType
            : !material.materialType;
        return sameId && sameType;
    });
    if (existed) {
        existed.count++;
        return materials;
    }
    const material = {
        materialId: item.resourceId,
        materialName: item.resourceName,
        count: 1,
    };
    if (materialType) {
        material.materialType = materialType;
    }
    materials.push(material);
    return materials;
}

function buildUseMaterials(objects = {}) {
    const materials = [];
    (objects.flowers || []).forEach(item => addMaterial(materials, item));
    addMaterial(materials, objects.container, { materialType: 'container' });
    return materials;
}

function getFlowerUseMaterials(useMaterials = []) {
    return useMaterials.filter(item => item.materialType !== 'container');
}

module.exports = {
    buildUseMaterials,
    getFlowerUseMaterials,
};
